import React from "react";
import { IonContent, IonPage, IonImg, IonButton } from "@ionic/react";
import "./Home.css";
import DifficultyIcon from "../components/DifficultyIcon";

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonContent>
        <div className="home-outer">
          <div className="home-inner">
            <IonImg
              className="home-image"
              src={require("../assets/images/Campaign_card.png")}
            />
            <IonButton
              color="primary"
              className="home-button"
              routerLink="/projects"
              routerDirection="none"
            >
              VIEW PROJECTS
            </IonButton>
            <div style={{ margin: "20px 0px" }}>
              <div className="home-icon-container">
                <h6 className="home-icon-text">Beginner</h6>
                <DifficultyIcon value={1} size={14} />
              </div>
              <div className="home-icon-container">
                <h6 className="home-icon-text">Intermediate</h6>
                <DifficultyIcon value={2} size={14} />
              </div>
              <div className="home-icon-container">
                <h6 className="home-icon-text">Advanced</h6>
                <DifficultyIcon value={3} size={14} />
              </div>
            </div>
            <a
              className="home-link"
              href="http://www.snappyxo.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              snappyxo.com
            </a>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default React.memo(Home);
